import { useEffect, useState } from "react";
import { server } from "../../server";
import axios from "axios";
import Select from "react-select";
import { toast } from "react-toastify";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { monthsList } from "../../utils";
import BusSeatView from "../../components/BusSeatView";

function UpdateStaffTransport() {
  const [error, setError] = useState(null);
  const { state } = useLocation();
  const staffId = state?.staffId;
  const [staffData, setStaffData] = useState(null);
  const [transport, setTransport] = useState([]);
  const [formData, setFormData] = useState({ transportFacility: {} });

  useEffect(() => {
    const fetchStudent = async () => {
      if (!staffId) {
        setError("Please enter Staff Id");
        return;
      }
      setLoading(true);
      setError(null);
      try {
        const response = await axios.post(
          `${server}/get_staff_data_mongodb`,
          { staffId: staffId },
          {
            headers: {
              Authorization: `${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          }
        );
        const staffData = response.data?.["body-json"]?.body;
        if (staffData) {
          setStaffData(staffData);
        } else {
          setError("No Student Data Found");
          setStaffData(null);
        }
      } catch (err) {
        setError("Student not found or API error.");
        setStaffData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchStudent();
  }, [staffId]);

  useEffect(() => {
    if (staffData) {
      setFormData((prev) => ({
        ...prev,
        transportFacility:
          staffData.transportFacility || prev.transportFacility,
      }));
    }
  }, [staffData]);

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value,
    }));
  };

  useEffect(() => {
    const matchedRoute = transport.find(
      (route) =>
        route.stoppage === formData.transportFacility.busStop &&
        route.vehicleNumber === formData.transportFacility.vehicleNo
    );

    if (matchedRoute) {
      setFormData((prev) => ({
        ...prev,
        transportFacility: {
          ...prev.transportFacility,
          busNumber: matchedRoute.busNo,
        },
      }));
    }
  }, [
    formData.transportFacility.busStop,
    formData.transportFacility.vehicleNo,
    transport,
  ]);

  const handleTransportFacilityChange = (e) => {
    const { name, value } = e.target;
    let updatedTransport = {
      ...formData.transportFacility,
      [name]: value,
    };

    if (name === "busStop") {
      const matchingRoutes = transport.filter(
        (route) => route.stoppage === value
      );

      if (matchingRoutes.length > 0) {
        updatedTransport.vehicleNo = matchingRoutes[0].vehicleNumber;
        updatedTransport.busNumber = matchingRoutes[0].busNumber;
      } else {
        updatedTransport.vehicleNo = "";
        updatedTransport.busNumber = "";
      }

      if (value === "") {
        updatedTransport.applicableMonth = "";
      }
    }

    if (name === "vehicleNo") {
      const route = transport.find(
        (route) =>
          route.stoppage === formData.transportFacility.busStop &&
          route.vehicleNumber === value
      );
      updatedTransport.busNumber = route ? route.busNumber : "";
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      transportFacility: updatedTransport,
    }));
  };

  useEffect(() => {
    axios
      .get(`${server}/getAllBusRoutesMongoDb`, {
        headers: {
          Authorization: `${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        const routes = response.data["body-json"]?.body?.routes;
        if (Array.isArray(routes)) {
          setTransport(routes);
        } else {
          console.error("Invalid data format from API", response.data);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("API Error:", error);
        setLoading(false);
      });
  }, []);

  const countFilledFields = (obj) => {
    return String(
      Object.values(obj).filter((value) => value !== "").length
    ).padStart(2, "0");
  };

  const getTotalFields = (obj) => {
    return String(Object.keys(obj).length).padStart(2, "0");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.put(
        `${server}/update_staff_transport_facility`,
        { ...formData, staffId: staffId },
        {
          headers: {
            Authorization: `${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      toast.success("Transport Updated", { position: "top-right" });
      navigate(-1);
    } catch (error) {
      toast.error("Please Try Again", { position: "top-right" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div id="db-wrapper">
        <main id="page-content">
          <div className="">
            <div class="container-fluid">
              <div class="row">
                <div class="col-lg-12 col-md-12 col-12">
                  <div class="m-3 mt-2 pt-1 d-flex justify-content-between">
                    <div class="d-flex align-items-center mt-2">
                      <span
                        onClick={() => window.history.back()}
                        class="back-button me-3 cursor-pointer"
                      >
                        <i className="bi bi-arrow-left fs-3"></i>
                      </span>
                      <nav aria-label="breadcrumb">
                        <h4 className="m-0 lh-sm">Update Transport</h4>
                        <ol class="breadcrumb pe-3 lh-sm">
                          <li class="breadcrumb-item">
                            <a href="#">Student Information</a>
                          </li>
                          <li class="breadcrumb-item">
                            <a href="#">Student Details</a>
                          </li>
                          <li
                            class="breadcrumb-item active"
                            aria-current="page"
                          >
                            Update Transport
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div class="container-fluid">
              <div className="row g-3">
                <div className="col-lg-8">
                  <form onSubmit={handleSubmit}>
                    <div class="px-5 py-3 mt-1 bg-white rounded-4">
                      <div>
                        <div>
                          <h3 class="m-0 fs-list">
                            <div class="d-flex align-items-center text-inherit">
                              <span class="me-auto fs-5">
                                Transport Facility{" "}
                                <span className="ms-3 text-secondary">
                                  (
                                  {countFilledFields(
                                    formData.transportFacility
                                  )}
                                  /{getTotalFields(formData.transportFacility)})
                                </span>
                              </span>
                              <div className="d-flex align-items-center">
                                <span className="badge px-3 bg-info-soft">
                                  If Availing
                                </span>
                              </div>
                            </div>
                          </h3>

                          <div>
                            <div className="row g-2 mt-2 mb-3">
                              <div className="col-lg-6 col-12">
                                <label className="form-label mb-1 ms-3">
                                  Bus Stoppage
                                </label>
                                <Select
                                  className="text-dark"
                                  name="busStop"
                                  value={{
                                    value: formData.transportFacility.busStop,
                                    label: formData.transportFacility.busStop,
                                  }}
                                  onChange={(selectedOption) =>
                                    handleTransportFacilityChange({
                                      target: {
                                        name: "busStop",
                                        value: selectedOption.value,
                                      },
                                    })
                                  }
                                  options={[
                                    { value: "", label: "NA" },
                                    ...Array.from(
                                      new Set(
                                        transport.map((route) => route.stoppage)
                                      )
                                    )
                                      .sort((a, b) => a.localeCompare(b))
                                      .map((stoppage) => ({
                                        value: stoppage,
                                        label:
                                          stoppage.charAt(0).toUpperCase() +
                                          stoppage.slice(1),
                                      })),
                                  ]}
                                />
                              </div>

                              <div className="col-lg-6 col-12">
                                <label className="form-label mb-1 ms-3">
                                  Vehicle No.{" "}
                                  <span className="text-danger ms-2">
                                    {formData?.transportFacility?.busNumber &&
                                      `(${formData.transportFacility.busNumber})`}
                                  </span>
                                </label>
                                <Select
                                  className="text-dark"
                                  name="vehicleNo"
                                  value={{
                                    value: formData.transportFacility.vehicleNo,
                                    label: formData.transportFacility.vehicleNo,
                                  }}
                                  onChange={(selectedOption) =>
                                    handleTransportFacilityChange({
                                      target: {
                                        name: "vehicleNo",
                                        value: selectedOption.value,
                                      },
                                    })
                                  }
                                  options={transport
                                    .filter(
                                      (route) =>
                                        route.stoppage ===
                                        formData.transportFacility.busStop
                                    )
                                    .map((route) => ({
                                      value: route.vehicleNumber,
                                      label: route.vehicleNumber,
                                    }))}
                                  isDisabled={
                                    !formData.transportFacility.busStop
                                  }
                                />
                              </div>

                              <div className="col-lg-6 col-12">
                                <label className="form-label mb-1 ms-3">
                                  Applicable Month
                                </label>
                                <Select
                                  className={`text-dark ${
                                    errors?.transportFacility?.applicableMonth
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="applicableMonth"
                                  value={{
                                    value:
                                      formData.transportFacility
                                        ?.applicableMonth,
                                    label:
                                      formData.transportFacility
                                        ?.applicableMonth,
                                  }}
                                  onChange={(selectedOption) =>
                                    handleTransportFacilityChange({
                                      target: {
                                        name: "applicableMonth",
                                        value: selectedOption.value,
                                      },
                                    })
                                  }
                                  options={monthsList.map((monthsName) => ({
                                    value: monthsName,
                                    label: monthsName,
                                  }))}
                                  placeholder="Select Applicable Month"
                                />
                              </div>
                            </div>

                            {formData.transportFacility.vehicleNo && (
                              <BusSeatView
                                vehicleNumber={
                                  formData.transportFacility.vehicleNo
                                }
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="my-3 d-flex float-end me-5">
                      <button type="submit" class="btn btn-success mt-2 px-6">
                        {loading ? (
                          <div
                            class="spinner-border spinner-border-sm"
                            role="status"
                          ></div>
                        ) : (
                          "Update"
                        )}
                      </button>
                    </div>
                  </form>
                </div>
                <div className="col-lg-4">
                  {staffData && (
                    <div className="sticky-top top-10 z-1 ">
                      <div className="p-5 bg-white rounded-4">
                        <div className="d-flex flex-column align-items-center">
                          <div>
                            <div class="icon-shape icon-xxl p-7 border rounded-3 position-relative overflow-hidden me-2">
                              <img
                                src={
                                  staffData?.basicDetails?.studentImage ||
                                  `/assets/images/profile.png`
                                }
                                alt="Image"
                                width="150"
                                height="150"
                                className="object-fit-cover rounded-3"
                              />
                            </div>
                            <div class="icon-shape icon-xxl p-7 border rounded-3 position-relative">
                              <img
                                src="https://cdn-icons-png.flaticon.com/512/14021/14021384.png"
                                className="w-100 position-absolute p-2 rounded-4"
                                alt="QR"
                              />
                            </div>
                          </div>

                          <div className="mt-3 text-center">
                            <h3 class="m-0 fs-4 lh-sm">
                              {staffData?.basicDetails?.fullName
                                .toLowerCase()
                                .replace(/\b\w/g, (char) =>
                                  char.toUpperCase()
                                )}{" "}
                              ({staffData?.staffId})
                            </h3>
                            <p className="m-0">
                              {staffData?.basicDetails?.bloodGroup},{" "}
                              {staffData?.basicDetails?.gender}
                            </p>
                            <p className="mt-3 mb-0 text-danger lh-sm">
                              (+91) {staffData?.basicDetails?.mobNo}
                              <br />
                              <span className="text-lowercase">
                                {staffData?.basicDetails?.emailId}
                              </span>
                            </p>
                            <p className="m-0 lh-sm mt-4 text-capitalize">
                              {staffData?.basicDetails?.permanentAddress
                                .toLowerCase()
                                .replace(/\b\w/g, (char) => char.toUpperCase())}
                            </p>
                            <p className="mt-3 mb-0 text-dark lh-sm">
                              Mr.{" "}
                              {staffData?.basicDetails?.fathersName
                                .toLowerCase()
                                .replace(/\b\w/g, (char) => char.toUpperCase())}
                              <br />
                              Mrs.{" "}
                              {staffData?.basicDetails?.mothersName
                                .toLowerCase()
                                .replace(/\b\w/g, (char) => char.toUpperCase())}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}

export default UpdateStaffTransport;
